import { render, staticRenderFns } from "./CheckboxModal.vue?vue&type=template&id=79f27829&"
import script from "./CheckboxModal.vue?vue&type=script&lang=js&"
export * from "./CheckboxModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports